module.exports = __webpack_public_path__ + "img/card_back.37293d91.png";